import React, { useEffect, useState } from "react";
import "./Articles.css";
import ArticleCard from "./ArticleCard";
import axios from "axios";
function Articles({ setOverlay = { setOverlay } }) {
  const url =
    "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@yuvraj-agarkar";
  let [articles, setArticles] = useState({});
  let [errText, setErrText] = useState(
    "Fetching data be patient... If there has been any issue You can read his Articles directly on Medium"
  );
  useEffect(() => {
    setOverlay("no_overlay");
    axios
      .get(url)
      .then((resp) => {
        setErrText("");
        setArticles({
          stat: true,
          items: resp.data.items,
        });
      })
      .catch((err) => {
        setArticles({
          stat: false,
        });
      });
  }, []);
  return (
    <div className="articles">
      <h2>Read My Articles on Medium</h2>
      <h4 className="errtext">{errText}</h4>
      <div className="articles__container">
        {articles?.items?.map((el) => (
          <ArticleCard title={el.title} imgSrc={el.thumbnail} link={el.link} />
        ))}
      </div>
    </div>
  );
}

export default Articles;
